const { DEV, VITE_LOCAL } = import.meta.env

import { watchOrReadListService as local } from './watchorreadlist.service.local'
import { watchOrReadListService as remote } from './watchorreadlist.service.remote'

function getEmptyList() {
  return {
    anizone_id: null, // מזהה ייחודי
    progress: 0, // התקדמות
    status: 'Plan to Watch', // סטטוס ברירת מחדל
    start_date: null, // תאריך התחלה
    finish_date: null, // תאריך סיום
    total_rewatchs: 0, // צפיות חוזרות
    metadata: {}, // שדה גמיש לתכונות נוספות
  }
}

const service = VITE_LOCAL === 'true' ? local : remote
export const watchOrReadListService = { ...service, getEmptyList }

// גישה קלה לשירות מה-console בזמן פיתוח
if (DEV) window.watchOrReadListService = watchOrReadListService
